import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";
import Login from "./pages/Auth1/login";
import Signup from "./pages/Auth1/signup";
import AccountSettings from "./pages/Auth1/AccountSettings";
import ConfirmEmail from "./pages/Auth1/ConfirmEmailPage";
import ResetPassword from "./pages/Auth1/ResetPasswordPage";
import ResetPW from "./pages/Auth1/ResetPWPage";
import ChangePasswordPage from "./pages/Auth1/ChangePasswordPage";
import About from "./pages/Home/About";
import Contact from "./pages/Home/Contact";
import Map from "./pages/Home/Map";
import Privacy from "./pages/WebPages/PrivacyPolicyPage";
import Terms from "./pages/WebPages/TermsPage";
import Speakers from "./pages/Home/speakers";
import Events from "./pages/Home/Events";
import NewsDetail from "./pages/Home/NewsDetails";
import News from "./pages/Home/News";
import OrganizerEvent from "./pages/Home/OrganizerEvent";
import OrganizerEventDetail from "./pages/Home/OrganizerEventDetail";
import AddEvent from "./pages/Home/AddEvent";
import EditEvent from "./pages/Home/EditEvent";
import ReceivedInvitations from "./pages/Home/ReceivedInvitations";
import MyFavorites from "./pages/Home/MyFavorites";
import Followers from "./pages/Home/Followers";
import MyEvents from "./pages/Home/MyEvents";
import MyContentManagementTabs from "./pages/Home/MyContentManagementTabs";
import Blogs from "./pages/Home/BlogSection";
import BlogDetail from "./pages/Home/BlogDetail";
import EventDetail from "./pages/Home/EventDetail";
import SpeakerDetail from "./pages/Home/speakerDetail";
import SpeakerBooking from "./pages/Home/SpeakerBooking";
import Profile from "./components/2Speakers/profile";
import ProfileEdit from "./components/2Speakers/ProfileEdit";
import MainLayout from "./components/2Layout/MainLayout";
import HomePageStatistics from "./components/AdminDashboardLayout/HomePageStatistics";
import IndestryManagementPage from "./components/AdminDashboardLayout/IndestryManagementPage";
import NewsManagementPage from "./components/AdminDashboardLayout/NewsManagementPage";
import UsersManagementPage from "./components/AdminDashboardLayout/UsersManagementPage";
import AdminLoginPage from "./components/AdminDashboardLayout/AdminLoginPage";
import ProtectedRoute from "../src/components/Auth/ProtectedRoute";

const App = () => {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/speakers" element={<Speakers />} />
        <Route path="/speaker-detail/:speakerId" element={<SpeakerDetail />} />
        <Route path="/speaker-booking" element={<SpeakerBooking />} />
        <Route path="/map" element={<Map />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />

        <Route path="/news" element={<News />} />
        <Route path="/news-detail/:newsId" element={<NewsDetail />} />
        <Route path="/events" element={<Events />} />
        <Route path="/event-detail/:eventId" element={<EventDetail />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blog-detail/:articleId" element={<BlogDetail />} />

        <Route path="/signup" element={<Signup />} />
        <Route path="/account-settings" element={<AccountSettings />} />
        <Route path="/login" element={<Login />} />
        <Route path="/confirm-email" element={<ConfirmEmail />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/reset-pw" element={<ResetPW />} />
        <Route path="/change-password" element={<ChangePasswordPage />} />

        {/* الصفحات المحمية  */}
        <Route
          path="/profile-edit"
          element={
            <ProtectedRoute>
              <ProfileEdit />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-content_management"
          element={
            <ProtectedRoute>
              <MyContentManagementTabs />
            </ProtectedRoute>
          }
        />

        <Route
          path="/organizer-events"
          element={
            <ProtectedRoute>
              <OrganizerEvent />
            </ProtectedRoute>
          }
        />
        <Route
          path="/organizer-event-detail/:eventId"
          element={
            <ProtectedRoute>
              <OrganizerEventDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/create-event"
          element={
            <ProtectedRoute>
              <AddEvent />
            </ProtectedRoute>
          }
        />
        <Route
          path="/update-event/:eventId"
          element={
            <ProtectedRoute>
              <EditEvent />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-favorites"
          element={
            <ProtectedRoute>
              <MyFavorites />
            </ProtectedRoute>
          }
        />
        <Route
          path="/followers"
          element={
            <ProtectedRoute>
              <Followers />
            </ProtectedRoute>
          }
        />

        <Route
          path="/my-events"
          element={
            <ProtectedRoute>
              <MyEvents />
            </ProtectedRoute>
          }
        />
        <Route
          path="/received-invitations"
          element={
            <ProtectedRoute>
              <ReceivedInvitations />
            </ProtectedRoute>
          }
        />

        {/* نهاية الصفحات المحمية */}
      </Route>

      {/* صفحات لا تحتوي ع MainLayout */}
      <Route
        path="/dashboard/industry-management"
        element={
          <ProtectedRoute>
            <IndestryManagementPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/statistics"
        element={
          <ProtectedRoute>
            <HomePageStatistics />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/news-management"
        element={
          <ProtectedRoute>
            <NewsManagementPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/users-management"
        element={
          <ProtectedRoute>
            <UsersManagementPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin-login"
        element={
            <AdminLoginPage />
        }
      />
    </Routes>
  );
};

export default App;
